/* @flow */
import Reflux from "reflux";

const SearchAction = Reflux.createActions([
    "query",
    "fetchSuggestions",
    "fetchFavourites",
    "cancelSuggestions",
    "list"
]);

export default SearchAction;
